import React from 'react'
// import Header from '../Menpages/Header/Main'

import Header from '../Menhome/Header'
import Bredcom from '../MenTeam/Bredcom'
import Footer from '../Menhome/Footer'
import Deliverypolicy from '../Menpages/Delivery-policy/main'


function DeliveryPolicy() {
  return (
    <>
    <Header/>
   
    <Bredcom title={"Policies"} head={"Delivery Policy"} sbtitle={"Delivery Policy"}/>
    <div className='px-[12%]'>
    <Deliverypolicy/>
    </div>
    <Footer/>
    </>
  )
}

export default DeliveryPolicy